import { FeatureSwitch } from '@if/core/types'

class FeatureFlags {
  public readonly useHighEstimate: boolean
  public readonly activateDownloadFCFButton: boolean
  public readonly showAdditionalSummaryVariables: boolean
  public readonly useBanishmentValidation: boolean
  public readonly useUnlockElitePromoForQuebecApplicants: boolean
  public readonly usePersonalMaxLoanLimit50K: boolean
  public readonly useMerchantDomainOnGetAppLinkButton: boolean

  constructor(featureSwitchDtos: FeatureSwitch[]) {
    const activatedFeatureSwitches = new Set(featureSwitchDtos.filter((x) => x.isActivated).map((x) => x.id))
    this.useHighEstimate = activatedFeatureSwitches.has('UseHighEstimate')
    this.activateDownloadFCFButton = activatedFeatureSwitches.has('ActivateDownloadFCFButton')
    this.showAdditionalSummaryVariables = activatedFeatureSwitches.has('ShowAdditionalSummaryVariables')
    this.useBanishmentValidation = activatedFeatureSwitches.has('UseBanishmentValidation')
    this.useUnlockElitePromoForQuebecApplicants = activatedFeatureSwitches.has('UseUnlockElitePromoForQuebecApplicants')
    this.usePersonalMaxLoanLimit50K = activatedFeatureSwitches.has('UsePersonalMaxLoanLimit50K')
    this.useMerchantDomainOnGetAppLinkButton = activatedFeatureSwitches.has('UseMerchantDomainOnGetAppLinkButton')
  }
}

export default FeatureFlags
